module.exports = __webpack_public_path__ + "fonts/Open_Sans-600-greek22.f2199da.woff2";